export interface ChoiceBucketLayout {
    top: number;
    height: number;
    left: number;
}

export function columnIndexAt(
    cx: number,
    innerWidth: number,
    columnCount: number,
    columnGap: number,
): number {
    const columnWidth = (innerWidth - (columnCount - 1) * columnGap) / columnCount;
    for (let i = 0; i < columnCount; i++) {
        const left = i * (columnWidth + columnGap);
        if (cx >= left && cx < left + columnWidth) {
            return i;
        }
    }
    return -1;
}

export function columnLeft(columnIndex: number, columnWidth: number, columnGap: number): number {
    return columnIndex * (columnWidth + columnGap);
}

/** Maps logical column index (0 = source, 1..N = choices) to visual left-to-right index. Symmetric for visual → logical. */
export function visualColumnIndex(
    logicalIndex: number,
    columnCount: number,
    isRtl: boolean,
): number {
    return isRtl ? columnCount - 1 - logicalIndex : logicalIndex;
}

export function choiceIndexAtMobile(
    cx: number,
    cy: number,
    sourceLeft: number,
    sourceWidth: number,
    choiceBucketLayouts: ChoiceBucketLayout[],
): number {
    if (cx >= sourceLeft && cx < sourceLeft + sourceWidth) {
        return -1;
    }

    for (let i = 0; i < choiceBucketLayouts.length; i++) {
        const { top, height } = choiceBucketLayouts[i];
        if (cy >= top && cy < top + height) {
            return i;
        }
    }

    return -1;
}
